import { Injector, Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import type { ISettingsRepository } from '@app/domain/ports';
import { SETTINGS_REPOSITORY } from '@app/platform/tokens';
import { BANK_INTEGRATION_PLUGINS, type BankIntegrationPlugin, PLUGIN_TRANSLATION_ASSETS } from '@app/ui/shared';
import { PumbSettingsService } from './pumb-settings.service';
import { PumbFileParserService } from './pumb-file-parser.service';
import { PumbSettingComponent } from './ui/pumb-setting.component';
import { PUMB_PARSER } from './pumb.tokens';
export { PUMB_PARSER };

export function providePumbPlugin(): Provider[] {
  return [
    {
      provide: PumbSettingsService,
      useFactory: (settings: ISettingsRepository, injector: Injector) => new PumbSettingsService(settings, injector),
      deps: [SETTINGS_REPOSITORY, Injector],
    },
    {
      provide: PUMB_PARSER,
      useFactory: () => new PumbFileParserService(),
    },
    {
      provide: PLUGIN_TRANSLATION_ASSETS,
      useValue: {
        pluginId: 'pumb',
        basePath: './assets/i18n/plugins/pumb',
        locales: ['en', 'pl', 'ru', 'uk'],
      },
      multi: true,
    },
    {
      provide: BANK_INTEGRATION_PLUGINS,
      useFactory: (
        translate: TranslateService,
        state: PumbSettingsService,
        dialogService: DialogService,
      ): BankIntegrationPlugin => ({
        id: 'pumb',
        order: 110,
        bankName: () => translate.instant('screens.pumb.labels.bank_name'),
        logoIcon: '/assets/images/banks/pumb.svg',
        settingsComponent: PumbSettingComponent,
        enabled: () => state.pumbEnabled(),
        openImport: () => {
          void import('./ui/pumb-import-dialog.component').then(({ PumbImportDialogComponent }) => {
            dialogService.open(PumbImportDialogComponent, {
              header: translate.instant('screens.pumb.titles.import_dialog'),
              styleClass: 'p-dialog-form p-dialog-maximized',
              modal: true,
              closable: true,
              focusOnShow: false,
            });
          });
        },
      }),
      deps: [TranslateService, PumbSettingsService, DialogService],
      multi: true,
    },
  ];
}
